const SettingsSection = ({ title, description, children, className = '' }) => (
  <section
    className={`rounded-3xl border border-[#E9EEF7] bg-white p-5 shadow-[0_2px_16px_rgba(15,23,42,0.04)] dark:border-white/[0.06] dark:bg-[#121826] dark:shadow-none ${className}`}
  >
    {(title || description) && (
      <div className="mb-4">
        {title ? (
          <h3 className="text-base font-bold text-surface-900 dark:text-white">{title}</h3>
        ) : null}
        {description ? (
          <p className="mt-1 text-xs leading-relaxed text-surface-500 dark:text-[#B5BDD1]">
            {description}
          </p>
        ) : null}
      </div>
    )}
    {children}
  </section>
);

export default SettingsSection;
